import React, { ReactElement } from 'react';
import ClickAwayListenerInternal from '@mui/material/ClickAwayListener';

const ClickAwayListener: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    onClickAway,
    children,
  } = props;

  return (
    <ClickAwayListenerInternal onClickAway={onClickAway}>
      {children}
    </ClickAwayListenerInternal>
  );
});

export default ClickAwayListener;
